"use client";
import { config } from "@grudder/lib/config";
import { API_KEY } from "@grudder/lib/const";
import { queryClient } from "@grudder/providers/QueryClientProviders";
import { getSession } from "next-auth/react";

// Common types and functions
type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
type NextConfig = Record<string, unknown>;

const getAuthHeaders = (session: any, url: string, method: HttpMethod): HeadersInit => {
  const headers: HeadersInit = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${session?.accessToken}`,
  };

  // Get organization domain from cookie on client side
  const cookies = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .reduce((acc, cookie) => {
      const [key, value] = cookie.split("=");
      if (key) acc[key] = value;
      return acc;
    }, {} as Record<string, string>);

  const orgDomain = cookies["organization-domain"];
  if (orgDomain) {
    headers["organization-domain"] = orgDomain;
  } else {
    //console.log("No organization domain found in cookies");
  }

  if (
    (url.includes("/api/organizations") && method === "POST") ||
    url.includes("/api/organizations/users") ||
    url.includes("/api/users/forgot-password") ||
    (url.includes("/api/users/invites")) ||
    ((url.includes("/api/users/user-settings")) && method == "DELETE")

  ) {
    headers["api-key"] = API_KEY;
  }
  return headers;
};

const handleResponse = async (res: Response) => {
  if (!res.ok) {
    if (res?.status === 401) {
      //console.log("Signing out");
      window.location.href = "/session-expired";
    }
    //console.log("handleResponse", res)
    const error = await res.json();
    throw { ...error, errorCode: res.status };
  }
  return res.json();
};

const makeAuthRequest = async (method: HttpMethod, url: string, payload?: any, nextConfig?: NextConfig) => {
  // console.log(method, url);
  const session: any = await getSession();
  // if (!session?.accessToken) {
  //   throw new Error("No a found");
  // }

  const options: RequestInit = {
    method,
    headers: getAuthHeaders(session, url, method),
    next: { revalidate: 0, ...nextConfig },
  };

  if (payload && method !== "GET") {
    options.body = JSON.stringify(payload);
  }

  const res = await fetch(url, options);

  console.log("Making Auth Request ===>", `URL:${url}`, `STATUS:${res?.status}`);
  return handleResponse(res);
};

// Exported functions
export const AUTH_GET = (url: string, nextConfig?: NextConfig) => {
  const tags = Array.isArray(nextConfig?.tags) ? nextConfig?.tags || [] : [];
  const cookies = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .reduce((acc, cookie) => {
      const [key, value] = cookie.split("=");
      if (key) acc[key] = value;
      return acc;
    }, {} as Record<string, string>);

  const orgDomain = cookies["organization-domain"];
  // console.log({ tags });
  // console.log("AUTH_GET", url);
  return queryClient.fetchQuery({
    queryKey: [`organization:${orgDomain}`, ...tags],
    queryFn: () => makeAuthRequest("GET", url, undefined, nextConfig),
  });
};

export const AUTH_POST = async (url: string, payload: any, nextConfig?: NextConfig) => {
  const cookies = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .reduce((acc, cookie) => {
      const [key, value] = cookie.split("=");
      if (key) acc[key] = value;
      return acc;
    }, {} as Record<string, string>);

  const orgDomain = cookies["organization-domain"];
  const tags = Array.isArray(nextConfig?.tags) ? nextConfig?.tags || [] : [];
  return queryClient.fetchQuery({
    queryKey: [`organization:${orgDomain}`, ...tags, `input:${JSON.stringify(payload)}`],
    queryFn: () => makeAuthRequest("POST", url, payload, nextConfig),
  });
};

export const AUTH_DELETE = async (url: string, nextConfig?: NextConfig) => makeAuthRequest("DELETE", url, undefined, nextConfig);

export const AUTH_PUT = async (url: string, payload: any, nextConfig?: NextConfig) => makeAuthRequest("PUT", url, payload, nextConfig);

export const AUTH_PATCH = async (url: string, payload: any, nextConfig?: NextConfig) => makeAuthRequest("PATCH", url, payload, nextConfig);

// export const AUTH_DELETE = async (url: string, nextConfig?: NextConfig) => makeAuthRequest("DELETE", url, undefined, nextConfig);

export const UPDATE_USER = async (userId: string, payload: { isActive: boolean; fullName: string }) => {
  return AUTH_PUT(`${config.baseURL}/api/users/${userId}`, payload);
};
